<template>
    <div>
        <div class="row">
            <div class="col-lg-6">
                <base-input alternative=""
                            :disabled="status.type === 'success' || admin"
                            required
                            label="Referenz"
                            placeholder="Anonymisierte Name für den Spielgast"
                            input-classes="form-control-alternative"
                            v-model="form.reference"
                />
            </div>
            <div class="col-lg-6">
                <label>Mitarbeiterprofil</label>
                <blockquote v-if="$router.currentRoute.name !== 'protocols_edit'" class="blockquote">
                    <p v-if="$store.getters['profiles/showActiveProfile'] !== null" class="mb-0"><mark>{{$store.getters['profiles/showActiveProfile'].name}}</mark></p>
                </blockquote>
                <blockquote v-else class="blockquote">
                    <p class="mb-0"><mark v-if="form.profile">{{form.profile.name}}</mark></p>
                </blockquote>
                <a v-if="$router.currentRoute.name !== 'protocols_edit'" href="#" class="text-sm text-info" @click.prevent="$store.dispatch('profiles/setNoActiveProfile')">Profil ändern</a>
            </div>
            <div v-if="!$store.getters['authentication/isService']" class="col-lg-4">
                    <label class="form-control-label">
                        Standort
                        <span>*</span></label>
                    <select v-model="form.location"
                            :disabled="status.type === 'success' || admin"
                            class="mb-3 custom-select form-control form-control-alternative form-control-lg">
                        <option :value="null" disabled>Bitte Standort wählen</option>
                        <option v-for="location in locations" :key="location.id" :value="location['@id']">{{ location.name }}
                        </option>
                    </select>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-10">
                <base-input alternative=""
                            :disabled="status.type === 'success' || admin"
                            label="Kommentar"
                            placeholder="Zusätzliche Angaben und Notizen zu diesem Protokoll können hier hinterlegt werden. (optional)"
                            input-classes="form-control-alternative"
                            v-model="form.comment"
                />
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Protocolform',
        props: {
          status: {},
          admin: {}
        },
        data() {
            return {
                form: {
                    reference: '',
                    comment: '',
                    profile: null,
                    form: null,
                    location: null
                }
            }
        },
        created() {
            if (!this.$store.getters['location/isReady']) this.$store.dispatch('location/getLocationCollection');
        },
        mounted() {
            if(this.$router.currentRoute.name !== "protocols_edit")
            {
                this.form.profile = this.$store.getters['profiles/showActiveProfile'];
                if(this.$store.getters['authentication/isService']) this.form.location = '/api/locations/'+this.$store.getters['authentication/location'];
            }

        },
        computed: {
            locations() {
                return (this.$store.getters['location/isReady']) ? this.$store.getters['location/showLocationCollection'] : null;
            },
        },

    }
</script>
